import { useState, useCallback } from 'react';
import { useRestClient } from '../WebServices/useRestClient';

export interface GetEntitiesRequest {
  entityIdentifiers: string;
}

export interface EntityResponse {
  name?: string;
  openingHours?: string;
  latitude?: string;
  longitude?: string;
  PhoneResponse?: {
    number?: string;
    dialingCode?: string;
  };
  EmailResponse?: {
    emailValue?: string;
  };
  AddressResponse?: {
    address1?: string;
    address2?: string;
    zipCode?: string;
    city?: string;
    country?: string;
  };
}

export interface EntitiesResponse {
  responseCode?: number | string;
  infos?: string;
  EntityResponses?: EntityResponse | EntityResponse[];
}

const useGetEntitiesREST = () => {
  const callRest = useRestClient();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<EntitiesResponse | null>(null);

  const fetchEntities = useCallback(
    async (entityIdentifiers: string) => {
      setLoading(true);
      setError(null);
      try {
        const result = await callRest<EntitiesResponse>('/rest/2.0/personWebService/getEntities', {
          method: 'POST',
          body: { entityIdentifiers },
          useAuth: true
        });
        setData(result);
        return result;
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Erreur appel REST';
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [callRest]
  );

  return { fetchEntities, loading, error, data };
};

export default useGetEntitiesREST;
